import * as OvationsApi from 'core/ovations-api';
import { times } from 'lodash';

export const mockImageRotatorImage: OvationsApi.Types.ImageRotatorImage = {
    linkUrl: 'http://test.com',
    id: 0,
    imageLocation: 'imageLocation',
    altText: 'altText',
    imageUrl: 'imageUrl',
};

export const mockImageRotatorImages: OvationsApi.Types.ImageRotatorImage[] = times(4, (i) => ({
    linkUrl: `http://test.com/${i}`,
    id: i,
    imageLocation: `imageLocation--${i}`,
    altText: `altText--${i}`,
    imageUrl: `imageUrl--${i}`,
}));
